<div>
  <mdb-breadcrumb>
    <mdb-breadcrumb-item routerLink="/" class="blue-text">Home</mdb-breadcrumb-item>
    <mdb-breadcrumb-item class="active">Disclaimer</mdb-breadcrumb-item>
  </mdb-breadcrumb>


  <div class="container">
    <div class="layer-bg-top-left" style="">
      <div class="layer-bg-bottom-right" style="">
        <div class="row mb-1 wow fadeIn" data-wow-delay="0.3s">
          <div class="col-md-12">
            <span class="component-title">
              Disclaimer for The Kenya Organic Agriculture Network
            </span>
          </div>
          <div class="col-md-12">
            <span class="content-3">
              If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at info@koan.co.ke
            </span>
          </div>
        </div>
        <hr>
        <div class="component-content">
          <div class="row shadow-md wow fadeIn" data-wow-delay="0.6s">
            <div class="col-12">
              <h3 class="content-1">
                Disclaimers for saferinputs.koan.co.ke
              </h3>
              <p class=" content-3">
                All the information on this website - www.saferinputs.koan.co.ke - is published in good faith and for general information purpose only. saferinputs.koan.co.ke does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (saferinputs.koan.co.ke), is strictly at your own risk. saferinputs.koan.co.ke will not be liable for any losses and/or damages in connection with the use of our website.
              </p>
              <p class=" content-3">
                From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.
              </p>
              <p class=" content-3">
                Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
              </p>
            </div>
            <div class="col-12">
            </div>
          </div>
          <hr>
          <div class="row shadow-md wow fadeIn" data-wow-delay="0.8s">
            <div class="col-12">
              <h3 class="content-1">
                Consent
              </h3>
              <p class=" content-3">
                By using our website, you hereby consent to our disclaimer and agree to its terms.
              </p>
            </div>
            <div class="col-12">
            </div>
          </div>
          <hr>
          <div class="row shadow-md wow fadeIn" data-wow-delay="1.0s">
            <div class="col-12">
              <h3 class="content-1">
                Update
              </h3>
              <p class=" content-3">
                Should we update, amend or make any changes to this document, those changes will be prominently posted here.
              </p>
            </div>
            <div class="col-12">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>



